import React from "react";
import TicketList from "./partials/ticket-list/ticket-list.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import OrderStore from "../stores/OrderStore";
import OrderActions from "../actions/OrderActions";

@connectToStores
class CompleteKioskOrder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      order: null,
      secondsRemaining: null
    };

    this.countdownStep = this.countdownStep.bind(this);
  }

  static getStores() {
    return [OrderStore];
  }

  static getPropsFromStores() {
    var state = OrderStore.getState();
    state.getOrderById = OrderStore.getOrderById;
    return state;
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired
    };
  }

  static componentDidConnect(props) {
    OrderActions.fetchOne(props.location.query.order);
  }

  getStyles() {
    return {
      container: {
        padding: 10,
        marginTop: 20,
        textAlign: "center",
        fontSize: "1.2em"
      },
      listing: {
        marginTop: 20,
        textAlign: "left",
        border: "1px solid #ccc"
      }
    };
  }

  countdownStep() {
    this.setState({
      secondsRemaining: this.state.secondsRemaining - 1
    });

    if (this.state.secondsRemaining <= 0) {
      clearInterval(this._countdownInterval);
      this.context.router.push("/schedule");
    }
  }

  componentWillReceiveProps(props) {
    var order = props.getOrderById(props.location.query.order);
    if (order && !this.state.order) {
      this.setState({
        order: order,
        secondsRemaining: 10
      });

      //OrderActions.printOrder(props.location.query.order);

      this._countdownInterval = setInterval(this.countdownStep, 1000);
    }
  }

  render() {
    var styles = this.getStyles();

    return (
      <div style={styles.container}>
        {this.state.order ? (
          <div>
            {this.state.order.success ? (
              <div>
                Your order has been completed successfully! Your tickets are now
                printing.
              </div>
            ) : (
              <div>
                Something went wrong during your order:{" "}
                {this.state.order.error_message}
              </div>
            )}
            <div>
              In {this.state.secondsRemaining} second
              {this.state.secondsRemaining !== 1 ? "s" : ""} the kiosk will
              automatically return to the schedule.
            </div>
            <div style={styles.listing}>
              <TicketList
                tickets={this.state.order.tickets}
                hideDateHeaders={true}
                hideActions={true}
              />
            </div>
          </div>
        ) : (
          <div>Loading order...</div>
        )}
      </div>
    );
  }
}

export default CompleteKioskOrder;



// WEBPACK FOOTER //
// ./src/app/components/complete-kiosk-order.jsx